import { render, staticRenderFns } from "./PreviewForm18.vue?vue&type=template&id=58d80859&scoped=true"
import script from "./PreviewForm18.vue?vue&type=script&lang=ts"
export * from "./PreviewForm18.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d80859",
  null
  
)

export default component.exports